import React from "react";

export interface IInputEditCross {
  focused: string;
  handleClose: Function;
  handleEdit: Function;
  onlyCross?: boolean;
  value: string;
}
export const InputEditCross = (props: IInputEditCross) => {
  return (
    <>
      {props?.focused === "focus" && props?.value !== "" && (
        <span
          className="edel-icon-withoutcolor-cross hand_cursor"
          onClick={(e) => {
            props?.handleClose(e);
          }}
        >
          <span className="path1"></span>
          <span className="path2"></span>
        </span>
      )}
      {props?.focused !== "focus" && !props?.onlyCross && (
        <span
          className="edel-icon-editicon-underline hand_cursor"
          onClick={(e) => props?.handleEdit(e)}
        ></span>
      )}
    </>
  );
};
